import { parse, stringify } from 'uuid';
import { Type } from '../Type';
export class RawList extends Array {
    type = Type.List;
    logicalType;
    tags;
    constructor(ids, logicalType, tags) {
        super(...ids.map((id) => stringify(parse(id))));
        this.tags = tags;
        this.logicalType = logicalType;
    }
    static get [Symbol.species]() {
        return Array;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUmF3TGlzdC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9saWIvdHlwZXMvbGlzdC9SYXdMaXN0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxLQUFLLEVBQUUsU0FBUyxFQUFFLE1BQU0sTUFBTSxDQUFBO0FBSXZDLE9BQU8sRUFBRSxJQUFJLEVBQUUsTUFBTSxTQUFTLENBQUE7QUFFOUIsTUFBTSxPQUFPLE9BQVEsU0FBUSxLQUFhO0lBQy9CLElBQUksR0FBUyxJQUFJLENBQUMsSUFBSSxDQUFBO0lBQ3RCLFdBQVcsQ0FBYztJQUN6QixJQUFJLENBQVc7SUFDeEIsWUFBWSxHQUFhLEVBQUUsV0FBeUIsRUFBRSxJQUFlO1FBQ25FLEtBQUssQ0FBQyxHQUFHLEdBQUcsQ0FBQyxHQUFHLENBQUMsQ0FBQyxFQUFFLEVBQUUsRUFBRSxDQUFDLFNBQVMsQ0FBQyxLQUFLLENBQUMsRUFBRSxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUE7UUFDL0MsSUFBSSxDQUFDLElBQUksR0FBRyxJQUFJLENBQUE7UUFDaEIsSUFBSSxDQUFDLFdBQVcsR0FBRyxXQUFXLENBQUE7SUFDaEMsQ0FBQztJQUVELE1BQU0sS0FBSyxDQUFDLE1BQU0sQ0FBQyxPQUFPLENBQUM7UUFDekIsT0FBTyxLQUFLLENBQUE7SUFDZCxDQUFDO0NBQ0YifQ==